import Cookies from 'js-cookie';

const CookiesStorage = {
  setItem(key, value, options) {
    Cookies.set(key, value, options);
  },
  getItem(key) {
    return Cookies.get(key);
  },
  del(key) {
    Cookies.remove(key);
  },
  clear() {
    const cookies = Cookies.get();
    Object.keys(cookies).forEach(key => {
      this.del(key);
    });
  },
};

export const StoreKey = {
  ID: 'ID',
  TOKEN: 'TOKEN',
  ACCESSCODE: 'ACCESSCODE',
  EXTRACT: 'EXTRACT',
};

const StoreKeyMap = {
  [StoreKey.ID]: {
    key: StoreKey.ID,
    type: 'cookie',
    encrypted: false,
  },
  [StoreKey.TOKEN]: {
    key: StoreKey.TOKEN,
    type: 'cookie',
    encrypted: false,
  },
  [StoreKey.ACCESSCODE]: {
    key: StoreKey.ACCESSCODE,
    type: 'cookie',
    encrypted: false,
  },
  [StoreKey.EXTRACT]: {
    key: StoreKey.EXTRACT,
    type: 'cookie',
    encrypted: false,
  },
};
class Store {
  constructor() {
    this.sessionStorage = window.sessionStorage;
    this.localStorage = window.localStorage;
    this.cookieStorage = CookiesStorage;
  }

  static formatKey(_key) {
    let type = 'session';
    let key = _key;
    if (StoreKeyMap[_key]) {
      const storeKey = StoreKeyMap[_key];
      key = storeKey.key;
      type = storeKey.type;
    }
    return { type, key };
  }

  add(_key, value, options = { expires: 1 }) {
    const { type, key } = Store.formatKey(_key);

    let o = value;
    const storage = this[`${type}Storage`];
    if (typeof value === 'object') {
      o = JSON.stringify(value);
    }
    storage.setItem(key, o, options);
  }

  get(_key) {
    const { type, key } = Store.formatKey(_key);

    const storage = this[`${type}Storage`];
    const value = storage.getItem(key);

    if (_key === StoreKey.EXTRACT) return value;

    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  del(_key) {
    const { type, key } = Store.formatKey(_key);

    const storage = this[`${type}Storage`];
    storage.removeItem(key);
  }

  flush(type = 'session') {
    const storage = this[`${type}Storage`];
    storage.clear();
  }
}

export default new Store();
